export default __webpack_public_path__ + "static/checkcurve-dd32201fc4f27cfd90c1e40a2f22df26.png";